{
  "list": {
    "title": "Teachers",
    "add": "Add Teacher"
  },
  "columns": {
    "name": "Name",
    "email": "Email",
    "payType": "Pay type",
    "payRate": "Pay rate"
  },
  "payType": {
    "perClass": "Per class",
    "monthlySalary": "Monthly salary"
  },
  "form": {
    "heading": "Add Teacher",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "payType": "Pay type",
    "payRate": "Pay rate",
    "currency": "Currency",
    "create": "Create",
    "nameEmailRequired": "Name and email are required"
  },
  "toast": {
    "created": "Teacher created",
    "failed": "Failed"
  },
  "detail": {
    "backToList": "Teachers",
    "email": "Email",
    "phone": "Phone",
    "payType": "Pay type",
    "payRate": "Pay rate",
    "assignedClasses": "Assigned classes",
    "noClasses": "No classes assigned",
    "columns": {
      "class": "Class",
      "day": "Day",
      "time": "Time",
      "enrolled": "Enrolled"
    }
  },
  "invite": {
    "heading": "Account access",
    "canLogin": "Can sign in",
    "canLoginHint": "This teacher has set a password and can log in.",
    "noLogin": "No login yet",
    "noLoginHint": "Send an invite so this teacher can set a password and sign in.",
    "send": "Send login invite",
    "resend": "Reset password",
    "sent": "Invite link generated.",
    "copy": "Copy",
    "copied": "Link copied.",
    "emailedNote": "We emailed this link to the teacher. You can also copy it:",
    "copyNote": "Email isn't configured — share this link with the teacher:"
  }
}
